import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { SharedHttp } from '../../../services/http-client.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LanguageService } from '../../../services/language.service';
let AdditionalUserInformationComponent = class AdditionalUserInformationComponent {
    constructor(auth, sanitizer, themeService, httpClient, formBuilder, languageService) {
        this.auth = auth;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.formBuilder = formBuilder;
        this.languageService = languageService;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.linkColor = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.lang = '';
        this.keyword = 'name';
        this.countries = [];
        this.countriesDropdownInFocus = false;
        this.countryError = false;
        this.cities = [];
        this.citiesDropdownInFocus = false;
        this.cityError = false;
        this.postalCodeError = false;
        this.addressLine1Error = false;
        this.addressLine2Error = false;
        this.professions = [];
        this.professionsByLang = [];
        this.dropdownProfessionInFocus = false;
        this.professionError = false;
        this.otherProfessionError = false;
        this.poaos = [];
        this.poaosByLang = [];
        this.dropdownPoaoInFocus = false;
        this.poaoError = false;
        this.otherPoaoError = false;
        this.allEmploymentTypes = [];
        this.allEmploymentTypesByLang = [];
        this.dropdownEmploymentTypeInFocus = false;
        this.employmentTypeError = false;
        this.eatas = [];
        this.eatasByLang = [];
        this.dropdownEataInFocus = false;
        this.eataError = false;
        this.otherEataError = false;
        this.additionalUserInfo = {};
        this.dataSubmittedLoader = false;
        this.dataSubmitted = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        });
        this.fetchUser();
        this.languageService.getChosenLanguage().subscribe((lang) => {
            var _a, _b, _c, _d;
            this.lang = lang ? lang : 'en';
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
            this.poaosByLang = this.poaos ? this.poaos.filter(poao => poao.lang === this.lang) : [];
            if (this.additionalUserInfo.employmentTypeId) {
                this.employmentTypesForm.get('employmentAutoComplete').patchValue((_a = this.allEmploymentTypesByLang.find(employmentType => employmentType.id === this.additionalUserInfo.employmentTypeId)) === null || _a === void 0 ? void 0 : _a.name);
            }
            if (this.additionalUserInfo.professionId) {
                this.professionsForm.get('professionsAutoComplete').patchValue((_b = this.professionsByLang.find(profession => profession.id === this.additionalUserInfo.professionId)) === null || _b === void 0 ? void 0 : _b.name);
            }
            if (this.additionalUserInfo.poao_id) {
                this.poaosForm.get('poaosAutoComplete').patchValue((_c = this.poaosByLang.find(poao => poao.id === this.additionalUserInfo.poao_id)) === null || _c === void 0 ? void 0 : _c.name);
            }
            if (this.additionalUserInfo.eata_id) {
                this.eatasForm.get('eatasAutoComplete').patchValue((_d = this.eatasByLang.find(eata => eata.id === this.additionalUserInfo.eata_id)) === null || _d === void 0 ? void 0 : _d.name);
            }
        });
        this.employmentTypesForm = this.formBuilder.group({
            employmentAutoComplete: ''
        });
        this.professionsForm = this.formBuilder.group({
            professionsAutoComplete: ''
        });
        this.poaosForm = this.formBuilder.group({
            poaosAutoComplete: ''
        });
        this.eatasForm = this.formBuilder.group({
            eatasAutoComplete: ''
        });
        this.citiesForm = this.formBuilder.group({
            citiesAutoComplete: ''
        });
    }
    ngOnInit() {
        this.getCountries();
        this.getProfessions();
        this.getPoaos();
        this.getEmploymentTypes();
        if (!this.isCompanyUser && !this.showNONEUAttribute) {
            this.getEatas();
        }
        this.citiesForm.get('citiesAutoComplete').disable();
    }
    fetchUser() {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.isCompanyUser = this.user.is_company_user;
        this.additionalUserInfo.userId = this.user.id;
        this.additionalUserInfo.otherProfession = '';
    }
    getCountries() {
        this.httpClient.get('user/registrationcountries').subscribe((data) => {
            this.countries = data;
        });
    }
    setCountry(item) {
        this.additionalUserInfo.countryId = item.id;
        this.getCitiesForCountryId(item.id);
    }
    onFocusedCountriesDropdown(e) {
        this.countriesDropdownInFocus = e;
        this.countryError = !e && !this.additionalUserInfo.countryId;
    }
    onCountriesDropdownClear(e) {
        this.additionalUserInfo.countryId = null;
        this.additionalUserInfo.cityId = null;
        this.additionalUserInfo.postalCode = null;
        this.citiesForm.get('citiesAutoComplete').setValue('');
        this.citiesForm.get('citiesAutoComplete').disable();
    }
    getCitiesForCountryId(countryId) {
        if (countryId !== '') {
            this.httpClient.get('user/registrationcities/' + countryId).subscribe((data) => {
                this.cities = data;
                this.citiesForm.get('citiesAutoComplete').enable();
            });
        }
    }
    setCity(item) {
        this.additionalUserInfo.cityId = item.id;
        this.additionalUserInfo.postalCode = item.postal_code;
    }
    onFocusedCitiesDropdown(e) {
        this.citiesDropdownInFocus = e;
        this.cityError = !e && !this.additionalUserInfo.cityId;
    }
    onCitiesDropdownClear(e) {
        this.additionalUserInfo.cityId = null;
        this.additionalUserInfo.postalCode = null;
    }
    checkAddressLine1() {
        this.addressLine1Error = !this.additionalUserInfo.address_line_1;
        return !this.addressLine1Error;
    }
    checkAddressLine2() {
        this.addressLine2Error = !this.additionalUserInfo.address_line_2;
        return !this.addressLine2Error;
    }
    checkPostalCode() {
        this.postalCodeError = !this.additionalUserInfo.postalCode;
    }
    getProfessions() {
        this.httpClient.get('user/professions').subscribe((data) => {
            this.professions = data;
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
        });
    }
    setProfession(item) {
        this.additionalUserInfo.professionId = item.id;
    }
    checkOtherProfession() {
        this.otherProfessionError = this.additionalUserInfo.professionId === -1 && !this.additionalUserInfo.otherProfession;
    }
    onFocusedProfession(e) {
        this.dropdownProfessionInFocus = e;
        this.professionError = !e && !this.additionalUserInfo.professionId;
    }
    onProfessionClear(e) {
        this.additionalUserInfo.professionId = null;
    }
    getPoaos() {
        this.httpClient.get('user/poaos').subscribe((data) => {
            this.poaos = data;
            this.poaosByLang = this.poaos ? this.poaos.filter(poao => poao.lang === this.lang) : [];
        });
    }
    setPoao(item) {
        this.additionalUserInfo.poao_id = parseInt(item.id);
    }
    onFocusedPoao(e) {
        this.dropdownPoaoInFocus = e;
        this.poaoError = !e && !this.additionalUserInfo.poao_id;
    }
    onPoaoClear(e) {
        this.additionalUserInfo.poao_id = null;
    }
    getEmploymentTypes() {
        this.httpClient.get('user/employmenttypes').subscribe((data) => {
            this.allEmploymentTypes = data;
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
        });
    }
    setEmploymentType(item) {
        this.additionalUserInfo.employmentTypeId = item.id;
    }
    onEmploymentTypeClear(e) {
        this.additionalUserInfo.employmentTypeId = null;
    }
    onFocusedEmploymentType(e) {
        this.dropdownEmploymentTypeInFocus = e;
        this.employmentTypeError = !e && !this.additionalUserInfo.employmentTypeId;
    }
    getEatas() {
        this.httpClient.get('user/eatas').subscribe((data) => {
            this.eatas = data;
            this.eatasByLang = this.eatas ? this.eatas.filter(eata => eata.lang === this.lang) : [];
        });
    }
    setEata(item) {
        this.additionalUserInfo.eata_id = parseInt(item.id);
    }
    onEataClear(e) {
        this.additionalUserInfo.eata_id = null;
    }
    onFocusedEata(e) {
        this.dropdownEataInFocus = e;
        this.eataError = !e && !this.additionalUserInfo.eata_id;
    }
    checkOtherEata() {
        this.otherEataError = this.additionalUserInfo.eata_id === -1 && !this.additionalUserInfo.otherEata;
    }
    checkOtherPoao() {
        this.otherPoaoError = this.additionalUserInfo.poao_id === -1 && !this.additionalUserInfo.otherPoao;
    }
    checkIfFormIsValid() {
        if (!this.additionalUserInfo.countryId || !this.additionalUserInfo.cityId || !this.additionalUserInfo.postalCode || !this.additionalUserInfo.address_line_1 || !this.additionalUserInfo.address_line_2 || this.additionalUserInfo.poao_id == null || (this.additionalUserInfo.poao_id === -1 && !this.additionalUserInfo.otherPoao)) {
            return true;
        }
        if (!this.isCompanyUser && (!this.additionalUserInfo.employmentTypeId || this.additionalUserInfo.professionId == null || (this.additionalUserInfo.professionId === -1 && !this.additionalUserInfo.otherProfession))) {
            return true;
        }
        if (!this.isCompanyUser && !this.showNONEUAttribute && (this.additionalUserInfo.eata_id == null || (this.additionalUserInfo.eata_id === -1 && !this.additionalUserInfo.otherEata))) {
            return true;
        }
        return false;
    }
    submitData() {
        this.dataSubmittedLoader = true;
        this.httpClient.post('user/setAddress', {
            user_id: this.additionalUserInfo.userId,
            address: this.additionalUserInfo.address,
            country_id: this.additionalUserInfo.countryId,
            city_id: this.additionalUserInfo.cityId,
            profession_id: this.additionalUserInfo.professionId,
            other_profession: this.additionalUserInfo.otherProfession,
            employmentTypeId: this.additionalUserInfo.employmentTypeId,
            eata_id: this.additionalUserInfo.eata_id,
            otherEata: this.additionalUserInfo.otherEata,
            poao_id: this.additionalUserInfo.poao_id,
            otherPoao: this.additionalUserInfo.otherPoao,
            address_line_1: this.additionalUserInfo.address_line_1,
            address_line_2: this.additionalUserInfo.address_line_2,
            postalCode: this.additionalUserInfo.postalCode
        }).subscribe((result) => {
            this.dataSubmittedLoader = false;
            this.dataSubmitted.emit(true);
        }, (error) => {
            this.dataSubmittedLoader = false;
        });
    }
};
AdditionalUserInformationComponent.ctorParameters = () => [
    { type: AuthService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: FormBuilder },
    { type: LanguageService }
];
__decorate([
    Input()
], AdditionalUserInformationComponent.prototype, "showNONEUAttribute", void 0);
__decorate([
    Output()
], AdditionalUserInformationComponent.prototype, "dataSubmitted", void 0);
AdditionalUserInformationComponent = __decorate([
    Component({
        selector: 'ecd-additional-user-information',
        template: __importDefault(require("./additional-user-information.component.html")).default,
    })
], AdditionalUserInformationComponent);
export { AdditionalUserInformationComponent };
